var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderComponentPackage',{attrs:{"apiUrl":_vm.getApiUrl,"themeColor":_vm.getThemeColor,"routes":_vm.menu,"authenticated":_vm.getAuthenticated,"companyObj":_vm.getUserCompany,"logoRoute":"/auth/get-logos-for-given-school"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }